export default "__VITE_ASSET__d82c5e85__"